(function () {
  'use strict';

  var root = document.querySelector('[data-meal-builder]');
  if (!root) return;

  var STORAGE_KEY = 'ccMealBuilder:v1';
  var form = root.querySelector('[data-meal-form]');
  var result = root.querySelector('[data-meal-result]');
  var error = root.querySelector('[data-meal-error]');
  var recipeList = root.querySelector('[data-recipe-list]');
  var recipeCount = root.querySelector('[data-recipe-count]');
  var search = root.querySelector('[data-recipe-search]');
  var filterButtons = Array.from(root.querySelectorAll('[data-recipe-filter]'));
  var activeFilter = 'all';

  var recipes = [
    {
      id: 'chicken-fajita-bowl', title: 'Chicken fajita rice bowl', meal: ['lunch', 'dinner'], diet: 'omnivore', time: '20',
      kcal: 615, protein: 52, carbs: 70, fat: 14, tags: ['high-protein', 'training', 'fat-loss'],
      ingredients: ['170g cooked chicken breast', '180g cooked basmati rice', '150g peppers and onion', '80g salsa', '30g reduced-fat Greek yoghurt', 'Fajita seasoning and lime'],
      method: ['Season and cook the chicken.', 'Cook the peppers and onion in the same pan.', 'Add rice to the bowl, then chicken, vegetables, salsa and yoghurt.'],
      note: 'Reduce rice for a lower-calorie day. Add rice or a wrap before a demanding session.'
    },
    {
      id: 'turkey-chilli', title: 'Turkey chilli and rice', meal: ['lunch', 'dinner'], diet: 'omnivore', time: 'batch',
      kcal: 650, protein: 50, carbs: 78, fat: 14, tags: ['high-protein', 'training', 'fat-loss'],
      ingredients: ['180g 5% turkey mince', '150g cooked kidney beans', '160g cooked rice', '200g chopped tomatoes', 'Onion, peppers, garlic and chilli spices'],
      method: ['Brown the turkey with onion and spices.', 'Add beans and tomatoes, then simmer for 20 minutes.', 'Serve with rice and divide extra portions for later.'],
      note: 'A reliable batch-cook meal. Beans add carbohydrate and fibre as well as some protein.'
    },
    {
      id: 'beef-pasta', title: 'Lean beef tomato pasta', meal: ['lunch', 'dinner'], diet: 'omnivore', time: 'batch',
      kcal: 705, protein: 48, carbs: 84, fat: 18, tags: ['high-protein', 'training'],
      ingredients: ['170g cooked 5% beef mince', '220g cooked pasta', '180g tomato and vegetable sauce', '10g parmesan', 'Italian herbs and black pepper'],
      method: ['Brown the mince and drain any excess fat.', 'Add tomato sauce and herbs, then simmer.', 'Stir through the cooked pasta and finish with parmesan.'],
      note: 'Use more pasta for a high-output day or more vegetables for a larger, lower-calorie plate.'
    },
    {
      id: 'salmon-potato', title: 'Salmon, potatoes and greens', meal: ['lunch', 'dinner'], diet: 'pescatarian', time: '20',
      kcal: 640, protein: 43, carbs: 58, fat: 25, tags: ['high-protein', 'training'],
      ingredients: ['170g salmon fillet', '300g baby potatoes', '200g green vegetables', 'Lemon, dill, salt and black pepper'],
      method: ['Roast or air-fry the salmon and potatoes.', 'Steam the greens.', 'Finish with lemon and dill.'],
      note: 'Salmon brings more fat than white fish. Keep added oils modest when calories are tight.'
    },
    {
      id: 'cod-traybake', title: 'Cod and Mediterranean tray bake', meal: ['lunch', 'dinner'], diet: 'pescatarian', time: '20',
      kcal: 510, protein: 48, carbs: 56, fat: 10, tags: ['high-protein', 'fat-loss'],
      ingredients: ['200g cod fillet', '280g potatoes', '200g courgette, tomato and pepper', '10g olive oil', 'Paprika, garlic and lemon'],
      method: ['Roast the potatoes for 15 minutes.', 'Add vegetables, cod and seasoning.', 'Cook until the fish flakes and the potatoes are tender.'],
      note: 'A high-volume option with lean protein. Add bread or more potato around hard training.'
    },
    {
      id: 'prawn-noodles', title: 'Prawn noodle stir-fry', meal: ['lunch', 'dinner'], diet: 'pescatarian', time: '10',
      kcal: 575, protein: 42, carbs: 76, fat: 12, tags: ['high-protein', 'training', 'quick'],
      ingredients: ['200g cooked prawns', '220g cooked noodles', '250g stir-fry vegetables', '15g reduced-salt soy sauce', '5g sesame oil, ginger and chilli'],
      method: ['Stir-fry the vegetables over high heat.', 'Add noodles, prawns, soy, ginger and chilli.', 'Finish with sesame oil after heating through.'],
      note: 'Fast and carbohydrate-forward. A useful pre- or post-training dinner.'
    },
    {
      id: 'tuna-wraps', title: 'Tuna crunch wraps', meal: ['lunch', 'snack'], diet: 'pescatarian', time: '10',
      kcal: 520, protein: 45, carbs: 57, fat: 12, tags: ['high-protein', 'fat-loss', 'quick'],
      ingredients: ['145g drained tuna in spring water', '2 medium wholemeal wraps', '60g Greek yoghurt', 'Lettuce, cucumber and tomato', 'Mustard, lemon and black pepper'],
      method: ['Mix tuna with yoghurt, mustard and lemon.', 'Fill wraps with salad and tuna.', 'Roll tightly and serve.'],
      note: 'No cooking required. Use one wrap and extra salad for a lighter meal.'
    },
    {
      id: 'chicken-curry', title: 'Chicken curry and basmati rice', meal: ['lunch', 'dinner'], diet: 'omnivore', time: 'batch',
      kcal: 675, protein: 50, carbs: 79, fat: 17, tags: ['high-protein', 'training'],
      ingredients: ['170g cooked chicken breast', '190g cooked basmati rice', '180g tomato curry sauce', '80g light coconut milk', 'Spinach, curry powder, garlic and ginger'],
      method: ['Cook the spices, garlic and ginger briefly.', 'Add chicken, tomatoes, coconut milk and spinach.', 'Simmer and serve with rice.'],
      note: 'Measure coconut milk and oil; both can move the calories quickly.'
    },
    {
      id: 'egg-bean-breakfast', title: 'Egg, bean and potato breakfast', meal: ['breakfast', 'lunch'], diet: 'vegetarian', time: '20',
      kcal: 590, protein: 32, carbs: 67, fat: 21, tags: ['training', 'vegetarian'],
      ingredients: ['3 eggs', '180g baked beans', '250g potatoes', 'Spinach and mushrooms', 'Paprika and black pepper'],
      method: ['Air-fry or pan-cook the potatoes.', 'Cook the spinach and mushrooms, then add eggs.', 'Heat the beans and serve together.'],
      note: 'For more protein, add egg whites or a side of Greek yoghurt.'
    },
    {
      id: 'protein-porridge', title: 'Protein porridge with berries', meal: ['breakfast'], diet: 'vegetarian', time: '10',
      kcal: 520, protein: 39, carbs: 68, fat: 11, tags: ['high-protein', 'training', 'vegetarian', 'quick'],
      ingredients: ['70g oats', '30g whey protein', '250ml semi-skimmed milk', '120g berries', '10g peanut butter', 'Cinnamon and a pinch of salt'],
      method: ['Cook oats with milk and a little water.', 'Remove from the heat and stir in whey.', 'Top with berries, peanut butter and cinnamon.'],
      note: 'A useful pre-training breakfast. Reduce peanut butter if you need lower fat before exercise.'
    },
    {
      id: 'yoghurt-bowl', title: 'Greek yoghurt power bowl', meal: ['breakfast', 'snack'], diet: 'vegetarian', time: '10',
      kcal: 445, protein: 39, carbs: 51, fat: 9, tags: ['high-protein', 'fat-loss', 'vegetarian', 'quick'],
      ingredients: ['300g 0% Greek yoghurt', '35g granola', '150g berries', '15g honey', '10g mixed seeds'],
      method: ['Add yoghurt to a bowl.', 'Top with fruit, granola, honey and seeds.', 'Mix just before eating.'],
      note: 'Use oats instead of granola for tighter calorie control. Check yoghurt and granola labels.'
    },
    {
      id: 'overnight-oats', title: 'Overnight oats for early starts', meal: ['breakfast'], diet: 'vegetarian', time: '10',
      kcal: 555, protein: 38, carbs: 73, fat: 12, tags: ['high-protein', 'training', 'vegetarian', 'quick'],
      ingredients: ['70g oats', '200g 0% Greek yoghurt', '150ml milk', '25g whey protein', '100g banana', 'Cinnamon'],
      method: ['Mix oats, yoghurt, milk, whey and cinnamon.', 'Refrigerate overnight.', 'Add banana before eating.'],
      note: 'Portable and easy to repeat. Add more milk if you prefer a looser texture.'
    },
    {
      id: 'tofu-teriyaki', title: 'Tofu teriyaki rice bowl', meal: ['lunch', 'dinner'], diet: 'vegan', time: '20',
      kcal: 645, protein: 34, carbs: 86, fat: 19, tags: ['training', 'vegetarian'],
      ingredients: ['220g firm tofu', '190g cooked rice', '250g mixed vegetables', '25g teriyaki sauce', '5g sesame oil'],
      method: ['Pat tofu dry, cube and brown in a hot pan.', 'Add vegetables and teriyaki sauce.', 'Serve over rice and finish with sesame oil.'],
      note: 'For more protein, add edamame or increase tofu while trimming the rice portion.'
    },
    {
      id: 'lentil-bolognese', title: 'Lentil bolognese', meal: ['lunch', 'dinner'], diet: 'vegan', time: 'batch',
      kcal: 610, protein: 30, carbs: 99, fat: 9, tags: ['training', 'fat-loss', 'vegetarian'],
      ingredients: ['220g cooked lentils', '220g cooked pasta', '220g tomato and vegetable sauce', 'Nutritional yeast, garlic and Italian herbs'],
      method: ['Cook onion, garlic and vegetables.', 'Add lentils, tomatoes and herbs, then simmer.', 'Serve with pasta and nutritional yeast.'],
      note: 'High in carbohydrate and fibre. Add tofu, seitan or a plant protein serving if your target is higher.'
    },
    {
      id: 'cottage-cheese-toast', title: 'Cottage cheese eggs on toast', meal: ['breakfast', 'lunch', 'snack'], diet: 'vegetarian', time: '10',
      kcal: 485, protein: 40, carbs: 42, fat: 17, tags: ['high-protein', 'fat-loss', 'vegetarian', 'quick'],
      ingredients: ['200g low-fat cottage cheese', '2 eggs', '2 slices wholemeal toast', 'Tomato and spinach', 'Chilli flakes and black pepper'],
      method: ['Toast the bread and cook the eggs.', 'Spread cottage cheese on toast.', 'Top with eggs, tomato, spinach and seasoning.'],
      note: 'A quick high-protein meal. Use one egg plus egg whites to reduce fat.'
    },
    {
      id: 'chicken-pesto-pasta', title: 'Chicken pesto pasta salad', meal: ['lunch', 'dinner'], diet: 'omnivore', time: '20',
      kcal: 690, protein: 51, carbs: 75, fat: 20, tags: ['high-protein', 'training'],
      ingredients: ['160g cooked chicken breast', '210g cooked pasta', '20g pesto', '150g tomatoes, spinach and peppers', 'Lemon and black pepper'],
      method: ['Cook and cool the pasta slightly.', 'Slice the chicken and vegetables.', 'Mix everything with pesto, lemon and pepper.'],
      note: 'Works hot or cold. Pesto is useful but energy-dense, so measure it.'
    },
    {
      id: 'beef-burrito', title: 'Lean beef burrito bowl', meal: ['lunch', 'dinner'], diet: 'omnivore', time: 'batch',
      kcal: 735, protein: 49, carbs: 89, fat: 20, tags: ['high-protein', 'training'],
      ingredients: ['160g cooked 5% beef mince', '170g cooked rice', '100g black beans', '100g salsa', '60g avocado', 'Lettuce, lime and taco spices'],
      method: ['Cook beef with taco spices.', 'Warm the rice and beans.', 'Build the bowl with salad, salsa, avocado and lime.'],
      note: 'A useful higher-energy meal. Reduce avocado or rice when calories need to come down.'
    },
    {
      id: 'skyr-fruit-snack', title: 'Skyr, fruit and cereal snack', meal: ['breakfast', 'snack'], diet: 'vegetarian', time: '10',
      kcal: 350, protein: 30, carbs: 50, fat: 4, tags: ['high-protein', 'training', 'fat-loss', 'vegetarian', 'quick'],
      ingredients: ['250g plain skyr', '35g cereal', '1 banana or apple', 'Cinnamon'],
      method: ['Add skyr to a bowl or container.', 'Top with cereal, fruit and cinnamon.', 'Eat immediately or keep chilled.'],
      note: 'Low fat and easy to digest for many people before training. Choose a cereal you tolerate well.'
    }
  ];

  var foodGroups = [
    {
      title: 'Protein foods', note: 'Cooked or ready to eat unless stated.',
      foods: [
        ['Chicken breast', 165, 31, 0, 4], ['Turkey mince 5%', 170, 29, 0, 5], ['Beef mince 5%', 172, 27, 0, 7],
        ['Salmon', 208, 25, 0, 13], ['Cod', 105, 23, 0, 1], ['Tuna, drained', 116, 26, 0, 1],
        ['Eggs, boiled', 143, 13, 1, 10], ['Greek yoghurt 0%', 59, 10, 4, 0], ['Firm tofu', 144, 17, 3, 9]
      ]
    },
    {
      title: 'Carbohydrate foods', note: 'Cooked weights except oats and bread.',
      foods: [
        ['Basmati rice', 130, 3, 28, 0], ['Potatoes, boiled', 87, 2, 20, 0], ['Pasta', 158, 6, 31, 1],
        ['Oats, dry', 379, 13, 68, 7], ['Sweet potato, baked', 90, 2, 21, 0], ['Wholemeal bread', 247, 9, 41, 4],
        ['Kidney beans', 127, 9, 23, 1], ['Banana', 89, 1, 23, 0]
      ]
    },
    {
      title: 'Higher-fat foods', note: 'Small serving changes can move calories quickly.',
      foods: [
        ['Olive oil', 884, 0, 0, 100], ['Peanut butter', 588, 25, 20, 50], ['Avocado', 160, 2, 9, 15],
        ['Almonds', 579, 21, 22, 50], ['Cheddar', 416, 25, 0, 35], ['Mixed seeds', 570, 24, 18, 47]
      ]
    }
  ];

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char];
    });
  }

  function listHtml(items, ordered) {
    var tag = ordered ? 'ol' : 'ul';
    return '<' + tag + '>' + items.map(function (item) { return '<li>' + escapeHtml(item) + '</li>'; }).join('') + '</' + tag + '>';
  }

  function recipeHtml(recipe) {
    return '<details class="ccl-recipe" data-recipe-id="' + recipe.id + '" data-tags="' + recipe.tags.join(' ') + '" data-search="' + escapeHtml((recipe.title + ' ' + recipe.ingredients.join(' ')).toLowerCase()) + '">' +
      '<summary><div><h3>' + escapeHtml(recipe.title) + '</h3><p>' + recipe.time.replace('batch', 'Batch cook') + (recipe.time === '10' || recipe.time === '20' ? ' minutes' : '') + '</p></div>' +
      '<div class="ccl-recipe__macros"><span>' + recipe.kcal + ' kcal</span><span>' + recipe.protein + 'g P</span><span>' + recipe.carbs + 'g C</span><span>' + recipe.fat + 'g F</span></div>' +
      '<span class="ccl-recipe__toggle" aria-hidden="true">+</span></summary>' +
      '<div class="ccl-recipe__body"><div><h4>One serving</h4>' + listHtml(recipe.ingredients, false) + '</div>' +
      '<div><h4>Method</h4>' + listHtml(recipe.method, true) + '<p class="ccl-recipe__tagline">' + escapeHtml(recipe.note) + '</p></div></div></details>';
  }

  function renderRecipes() {
    recipeList.innerHTML = recipes.map(recipeHtml).join('');
    applyRecipeFilters();
  }

  function foodGroupHtml(group) {
    var rows = group.foods.map(function (food) {
      return '<tr><td>' + escapeHtml(food[0]) + '</td><td>' + food[1] + '</td><td>' + food[2] + '</td><td>' + food[3] + '</td><td>' + food[4] + '</td></tr>';
    }).join('');
    return '<section class="ccl-food-group"><h3>' + escapeHtml(group.title) + '</h3><p>' + escapeHtml(group.note) + '</p>' +
      '<div class="ccl-table-wrap"><table><thead><tr><th>Food</th><th>kcal</th><th>P</th><th>C</th><th>F</th></tr></thead><tbody>' + rows + '</tbody></table></div></section>';
  }

  function renderFoodReference() {
    var container = root.querySelector('[data-food-reference]');
    container.innerHTML = foodGroups.map(foodGroupHtml).join('');
  }

  function isDietMatch(recipeDiet, selectedDiet) {
    if (selectedDiet === 'any') return true;
    if (selectedDiet === 'pescatarian') return ['pescatarian', 'vegetarian', 'vegan'].indexOf(recipeDiet) !== -1;
    if (selectedDiet === 'vegetarian') return ['vegetarian', 'vegan'].indexOf(recipeDiet) !== -1;
    return recipeDiet === 'vegan';
  }

  function isTimeMatch(recipeTime, selectedTime) {
    if (selectedTime === 'any') return true;
    if (selectedTime === '10') return recipeTime === '10';
    if (selectedTime === '20') return recipeTime === '10' || recipeTime === '20';
    return recipeTime === 'batch';
  }

  function purposeBonus(recipe, purpose) {
    if (purpose === 'fat-loss') return recipe.tags.indexOf('fat-loss') !== -1 ? -0.35 : 0.2;
    if (purpose === 'pre-training' || purpose === 'post-training' || purpose === 'higher-energy') return recipe.tags.indexOf('training') !== -1 ? -0.25 : 0.15;
    return 0;
  }

  function buildMeal(event) {
    event.preventDefault();
    error.textContent = '';

    var data = new FormData(form);
    var calories = Number(data.get('calories'));
    var protein = Number(data.get('protein'));
    var purpose = data.get('purpose');
    var mealType = data.get('mealType');
    var diet = data.get('diet');
    var time = data.get('time');

    if (!Number.isFinite(calories) || calories < 250 || calories > 1500 || !Number.isFinite(protein) || protein < 15 || protein > 100) {
      error.textContent = 'Enter a meal target between 250-1,500 kcal and 15-100g protein.';
      return;
    }

    var matches = recipes.filter(function (recipe) {
      return isDietMatch(recipe.diet, diet) && isTimeMatch(recipe.time, time) && (mealType === 'any' || recipe.meal.indexOf(mealType) !== -1);
    });

    if (!matches.length) {
      matches = recipes.filter(function (recipe) { return isDietMatch(recipe.diet, diet); });
    }

    matches.sort(function (a, b) {
      var aScore = Math.abs(a.kcal - calories) / calories + (Math.abs(a.protein - protein) / protein) * 1.35 + purposeBonus(a, purpose);
      var bScore = Math.abs(b.kcal - calories) / calories + (Math.abs(b.protein - protein) / protein) * 1.35 + purposeBonus(b, purpose);
      return aScore - bScore;
    });

    var topMatches = matches.slice(0, 3);
    var purposeCopy = {
      'everyday': 'Build a balanced meal you can repeat.',
      'fat-loss': 'Keep protein and food volume high. Measure oils, sauces and calorie-dense extras.',
      'pre-training': 'Prioritise carbohydrate and familiar foods. Keep fat and fibre lower if your stomach is sensitive.',
      'post-training': 'Replace carbohydrate and get a useful protein serving. The whole day still matters more than one narrow window.',
      'higher-energy': 'Increase the carbohydrate portion first, especially around demanding running or conditioning.'
    }[purpose];

    var matchHtml = topMatches.map(function (recipe, index) {
      var calorieDifference = recipe.kcal - calories;
      var adjustment = Math.abs(calorieDifference) <= 75 ? 'Close to target as written.' : (calorieDifference > 0 ? 'Use a slightly smaller carbohydrate or fat portion.' : 'Add carbohydrate or a measured fat serving.');
      return '<article class="ccl-match"><div class="ccl-match__top"><h3>' + escapeHtml(recipe.title) + '</h3><span>' + (index === 0 ? 'Best match' : 'Alternative') + '</span></div>' +
        '<div class="ccl-match__macros"><span>' + recipe.kcal + ' kcal</span><span>' + recipe.protein + 'g protein</span><span>' + recipe.carbs + 'g carbs</span><span>' + recipe.fat + 'g fat</span></div>' +
        '<p>' + adjustment + ' Open it in the recipe bank for ingredients and method.</p></article>';
    }).join('');

    result.innerHTML = '<p class="ccl-kicker">Closest matches</p><h2>' + escapeHtml(purposeCopy) + '</h2>' +
      '<div class="ccl-result__target"><span>' + calories + ' kcal</span><span>' + protein + 'g protein</span><span>' + escapeHtml(diet === 'any' ? 'No diet filter' : diet) + '</span></div>' +
      '<div class="ccl-match-list">' + matchHtml + '</div>' +
      '<p class="ccl-result__note">Recipe values are estimates. Adjust one ingredient at a time and use the packet label when exact tracking matters.</p>';

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ calories: calories, protein: protein, purpose: purpose, mealType: mealType, diet: diet, time: time }));
    } catch (storageError) {
      // The builder still works when local storage is unavailable.
    }

    if (window.matchMedia('(max-width: 920px)').matches) result.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function applyRecipeFilters() {
    var query = (search.value || '').trim().toLowerCase();
    var visible = 0;
    Array.from(recipeList.querySelectorAll('.ccl-recipe')).forEach(function (recipe) {
      var matchesFilter = activeFilter === 'all' || recipe.dataset.tags.split(' ').indexOf(activeFilter) !== -1;
      var matchesSearch = !query || recipe.dataset.search.indexOf(query) !== -1;
      recipe.hidden = !(matchesFilter && matchesSearch);
      if (!recipe.hidden) visible += 1;
    });
    recipeCount.textContent = visible + (visible === 1 ? ' recipe' : ' recipes');
  }

  function restoreForm() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved) return;
      Object.keys(saved).forEach(function (name) {
        if (form.elements[name]) form.elements[name].value = saved[name];
      });
    } catch (storageError) {
      return;
    }
  }

  form.addEventListener('submit', buildMeal);
  search.addEventListener('input', applyRecipeFilters);
  filterButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      activeFilter = button.dataset.recipeFilter;
      filterButtons.forEach(function (item) { item.classList.toggle('is-active', item === button); });
      applyRecipeFilters();
    });
  });

  restoreForm();
  renderRecipes();
  renderFoodReference();
})();
